/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Power unit of measure. Supported value is:
 * - kW (Kilowatt)
 *
 */
export var PowerUomEnum;
(function (PowerUomEnum) {
    PowerUomEnum["K_W"] = "kW";
})(PowerUomEnum || (PowerUomEnum = {}));
